import { render, staticRenderFns } from "./SimpleView.vue?vue&type=template&id=2e154924&scoped=true&"
import script from "./SimpleView.vue?vue&type=script&lang=js&"
export * from "./SimpleView.vue?vue&type=script&lang=js&"
import style0 from "./SimpleView.vue?vue&type=style&index=0&id=2e154924&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e154924",
  null
  
)

export default component.exports